<header class="header" role="banner">
  <div class="header__wrapper">

    <a routerLink="/init" class="header__logo" aria-label="Ir al inicio">
      <img src="assets/images/logo_dark.png?v=2103" alt="GenAI Developer Booster" width="942" height="399" />
    </a>

    <nav *ngIf="tabs?.length" class="header__tabs" role="tablist">
      <button
        *ngFor="let tab of tabs"
        type="button"
        role="tab"
        class="header__tab"
        [class.active]="activeTab === tab.id"
        [attr.aria-selected]="activeTab === tab.id"
        (click)="tabChange.emit(tab.id)">
        {{ tab.labelKey | translate }}
      </button>
    </nav>

    <div class="header__spacer"></div>

    <div class="header__selectors">
      <app-client-selector (clientChanged)="clientChanged($event)" [isSuperadmin]="isSuperadmin"></app-client-selector>
      <app-project-selector
        *ngIf="selectedClient && selectedClient.id && userProjects"
        [projects]="userProjects"
        [selectedProjectId]="selectedProjectId"
        (projectChanged)="onProjectChanged($event)">
      </app-project-selector>
    </div>

    <div class="header__user">
      <button
        class="header__avatar"
        (click)="toggleUserDropdown()"
        [attr.aria-expanded]="showUserDropdown"
        aria-haspopup="true"
        [title]="'HEADER.PROFILE' | translate">
        {{ userInitials }}
      </button>

      <ul *ngIf="showUserDropdown" class="header__dropdown" role="menu">
        <!-- INETUM2025-1914: sin esta entrada, el mensaje que el conector lleva tiempo dando al
             usuario ("Configuralo en Genaidb -> Menu de Avatar -> Configurar JIRA") apuntaba a un
             sitio que no existia. Va sin *ngIf: la credencial de tracker es personal y cualquier
             usuario autenticado tiene la suya. -->
        <li role="none">
          <a routerLink="/jira-config" class="header__dropdown-item" role="menuitem" (click)="showUserDropdown=false">
            <ion-icon name="key-outline" aria-hidden="true"></ion-icon>
            {{ 'HEADER.TRACKER_CREDENTIALS' | translate }}
          </a>
        </li>
        <li role="none" *ngIf="isSuperadmin">
          <a routerLink="/gdb/audit-agent" class="header__dropdown-item" role="menuitem" (click)="showUserDropdown=false">
            <ion-icon name="sparkles-outline" aria-hidden="true"></ion-icon>
            {{ 'HEADER.AUDIT_AGENT' | translate }}
          </a>
        </li>
        <li role="none" *ngIf="isSuperadmin || isClientAdmin">
          <a routerLink="/gdb/admin" class="header__dropdown-item" role="menuitem" (click)="showUserDropdown=false">
            <ion-icon name="settings-outline" aria-hidden="true"></ion-icon>
            {{ 'HEADER.ADMIN' | translate }}
          </a>
        </li>
        <!-- INETUM2025-2027: P-02 (conexion de tracker de la organizacion) no tenia entrada de menu;
             solo se llegaba por URL o por el aviso NO_TENANT_CONFIG del chat. Misma condicion que
             "Administracion", que es la del AdminGuard que ya protege la ruta. -->
        <li role="none" *ngIf="isSuperadmin || isClientAdmin">
          <a routerLink="/gdb/admin/tracker-connections" class="header__dropdown-item" role="menuitem" (click)="showUserDropdown=false">
            <ion-icon name="link-outline" aria-hidden="true"></ion-icon>
            {{ 'HEADER.TRACKER_CONNECTIONS' | translate }}
          </a>
        </li>
        <!-- P-10 (perfiles de ciclo de vida) no tenia entrada de menu; solo se llegaba por URL. Va
             con el rol del proyecto activo, MANAGER o superior, que es lo que exige el backend. -->
        <li role="none" *ngIf="canAdminProfiles">
          <a routerLink="/gdb/perfiles" class="header__dropdown-item" role="menuitem" (click)="showUserDropdown=false">
            <ion-icon name="people-outline" aria-hidden="true"></ion-icon>
            {{ 'HEADER.LIFECYCLE_PROFILES' | translate }}
          </a>
        </li>
        <li role="none" *ngIf="isSuperadmin || isClientAdmin">
          <a routerLink="/gdb/auditory" class="header__dropdown-item" role="menuitem" (click)="showUserDropdown=false">
            <ion-icon name="stats-chart-outline" aria-hidden="true"></ion-icon>
            {{ 'HEADER.AUDITORY' | translate }}
          </a>
        </li>
        <li role="none" *ngIf="isSuperadmin || isClientAdmin">
          <a routerLink="/gdb/announcements/release-notes" class="header__dropdown-item" role="menuitem" (click)="showUserDropdown=false">
            <ion-icon name="mail-outline" aria-hidden="true"></ion-icon>
            {{ 'HEADER.ANNOUNCEMENTS_RELEASE_NOTES' | translate }}
          </a>
        </li>
        <li role="none" *ngIf="isSuperadmin || isClientAdmin">
          <a routerLink="/gdb/announcements/maintenance-notice" class="header__dropdown-item" role="menuitem" (click)="showUserDropdown=false">
            <ion-icon name="mail-outline" aria-hidden="true"></ion-icon>
            {{ 'HEADER.ANNOUNCEMENTS_MAINTENANCE' | translate }}
          </a>
        </li>
        <li role="none">
          <button class="header__dropdown-item" role="menuitem" (click)="openChangelog(); showUserDropdown=false">
            <ion-icon name="newspaper-outline" aria-hidden="true"></ion-icon>
            {{ 'HEADER.NOVEDADES' | translate }}
          </button>
        </li>
        <li role="none" class="header__dropdown-divider" aria-hidden="true"></li>
        <li role="none">
          <button class="header__dropdown-item header__dropdown-item--danger" role="menuitem" (click)="logout()">
            <ion-icon name="log-out-outline" aria-hidden="true"></ion-icon>
            {{ 'HEADER.CLOSE_SESSION' | translate }}
          </button>
        </li>
      </ul>
    </div>

  </div>
</header>

<app-changelog-modal
  *ngIf="showChangelog"
  (closeModal)="closeChangelog()">
</app-changelog-modal>
